// src/modules/app-views/products/pages/Ai/components/WelcomeScreen.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Flex } from 'antd';
import SimpleButton from 'components/SimpleComponents/SimpleButton';
import translateX from 'utils/translateX';
import ProductsAiHeader from './ProductsAiHeader';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
/**
 * WelcomeScreen - Initial menu screen with options
 */
const WelcomeScreen = ({ isMobile, onInsertWithAi, onInsertManually }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. EFFECTS II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <ProductsAiHeader isMobile={isMobile}>
      <Flex gap={12} vertical={isMobile} justify="center" align="center">
        <SimpleButton
          type="primary"
          title={translateX('insert_with_ai')}
          onClick={onInsertWithAi}
          style={{ width: 160 }}
        />
        <SimpleButton
          type="default"
          title={translateX('insert_manually')}
          onClick={() => onInsertManually()}
          style={{ width: 160 }}
        />
      </Flex>
    </ProductsAiHeader>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default WelcomeScreen;
